import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appNumberInput]',
})
export class NumberInputDirective {
  @Input()
  set model(value) {
    value = String(value);
    if (this._isValid(value)) {
      this.elementRef.nativeElement.value = value;
    } else {
      this.modelChange.emit('');
    }
  }
  @Output() modelChange = new EventEmitter<string>();

  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    if ([8, 9].includes(event.keyCode)) {
      setTimeout(() => {
        this.modelChange.emit(event.target.value);
      }, 0);
      return;
    }
    event.preventDefault();
    const value = event.target.value;
    const nextValue =
      document.getSelection().toString() === value
        ? event.key
        : value + '' + event.key;
    if (this._isValid(nextValue)) {
      event.target.value = nextValue;
      this.modelChange.emit(nextValue);
    }
  }

  constructor(private elementRef: ElementRef) {}

  private _isValid(value) {
    return /^[0-9]*$/.test(value);
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/directives/number-input.directive.ts